import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Overview.css';
import overviewImage from '../assets/images/overview-updated.png';

const Overview = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="overview" className="overview" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Overview</h2>
          <p className="section-subtitle">From waste to resource — a holistic, circular solution to the plastic waste crisis</p>
        </motion.div>

        <motion.div
          className="overview-content"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.p
            className="lead-text"
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            Latent Energy has developed a disruptive technology that transforms unsorted plastic and complex packaging waste into high-value circular-carbon fuels and commodities, sustainably and profitably, independent of any incentives and regulation. A truly circular solution.
          </motion.p>
        </motion.div>

        <motion.div
          className="overview-image-wrapper"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <img src={overviewImage} alt="Overview Statistics" className="overview-image" />
        </motion.div>
      </div>
    </section>
  );
};

export default Overview;
